import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar";
import Navbar from "../navbar";

const Layout: React.FC = () => {
  return (
    <div>
      <Navbar />
      <div className="page-container">
        <div className="page-content">
          <Sidebar />
          <div className="content-wrapper">
            {/* <div className="page-header">
              <div className="page-header-content">
                <div className="page-title">
                  <span className="page-title-text">RFM Analysis</span>
                </div>
              </div>
            </div> */}
            {/* Only this part will change dynamically */}
            <div className="content">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
